/**
 * KnorShot CRO JavaScript
 * Free-shipping bar (live update) and the cart upsell that replaces the bottle by the box.
 *
 * The delivery promise ("morgen in huis") and the countdown to 22:00 are removed on purpose:
 * that promise is not kept and may not appear anywhere.
 */
(function () {
  'use strict';

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var BOTTLES_PER_BOX = 6;

  // Amounts as the shipping texts write them: a non-breaking space after the euro sign,
  // and the threshold without ",00".
  function euro(cents, dropZeroCents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    if (dropZeroCents) s = s.replace(/,00$/, '');
    return '\u20ac\u00a0' + s;
  }

  // ── Cart shipping line live update ────────────────────────────────────────
  // The threshold and the fee come from the line's own data attributes, which Liquid fills from
  // snippets/knorshot-shipping-bar.liquid, the single source of the shipping rule. The line states
  // the tariff only, no progress bar (legal-red-team round 3, 2026-10-31).
  function updateShippingBar() {
    var bar = document.querySelector('.kcart-ship');
    if (!bar) return;
    var text = bar.querySelector('.kcart-ship__text');
    var itemsEl = document.querySelector('[data-cart-items-cents]');
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    var fee = parseInt(bar.getAttribute('data-fee'), 10);
    if (!text || !itemsEl || !threshold || isNaN(fee)) return;

    // The goods only, after discounts: the summary total also carries the shipping fee.
    var numeric = parseInt(itemsEl.getAttribute('data-cart-items-cents'), 10);
    if (isNaN(numeric)) return;

    if (Math.round(numeric) >= threshold) {
      text.innerHTML = 'Verzendkosten <span class="k-money">' + euro(0) + '</span>, tenzij een kortingscode bij het afrekenen het bedrag onder <span class="k-money">' + euro(threshold, true) + '</span> brengt.';
      text.classList.add('kcart-ship__text--done');
    } else {
      text.innerHTML = 'Verzendkosten <span class="k-money">' + euro(fee) + '</span>. Vanaf <span class="k-money">' + euro(threshold, true) + '</span> aan producten, na alle kortingen: <span class="k-money">' + euro(0) + '</span>.';
      text.classList.remove('kcart-ship__text--done');
    }
  }

  // ── Upsell: replace the bottle line by the box (kw-1c behaviour) ──────────
  function asJson(response) {
    if (!response.ok) throw new Error('HTTP ' + response.status);
    return response.json();
  }

  function initUpgrade() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var button = target.closest('[data-kcart-upgrade]');
      if (!button) return;
      event.preventDefault();

      var flesId = parseInt(button.getAttribute('data-fles-variant'), 10);
      var doosId = parseInt(button.getAttribute('data-doos-variant'), 10);
      var label = button.textContent;
      button.textContent = 'Bezig...';
      button.disabled = true;

      // One chain: read the cart, add the box, then lower the bottle line by the six bottles the box holds.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(asJson)
        .then(function (cart) {
          var line = null;
          cart.items.forEach(function (item) {
            if (!line && item.variant_id === flesId) line = item;
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ id: doosId, quantity: 1 })
          })
            .then(asJson)
            .then(function () {
              if (!line) return null;
              // The box is in the cart now: a failing change leaves box plus bottle, so reload to show the true cart.
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: JSON_HEADERS,
                body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - BOTTLES_PER_BOX) })
              })
                .then(asJson)
                .catch(function () {
                  return null;
                });
            });
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = label;
        });
    });
  }

  // ── Product page sub-nav (kw-3c) ───────────────────────────────────────────
  // The small add button presses the add-to-cart button of the buy box, so quantity,
  // variant and cart behaviour stay the theme's own. The current tab follows the scroll.
  function initSubnav() {
    var nav = document.querySelector('.kpdp-subnav');
    if (!nav) return;

    var add = nav.querySelector('[data-kpdp-subnav-add]');
    if (add) {
      add.addEventListener('click', function () {
        var main = document.querySelector('product-form-component button.add-to-cart-button');
        if (main) main.click();
      });
    }

    // The bar only shows once the buy box button has scrolled out of view above.
    var wrap = nav.closest('.kpdp-subnav-wrap') || nav.parentElement;
    var buy = document.querySelector('product-form-component button.add-to-cart-button');
    function sync() {
      if (!wrap || !buy) return;
      var past = buy.getBoundingClientRect().bottom < 0;
      if (past) wrap.setAttribute('data-kpdp-shown', '');
      else wrap.removeAttribute('data-kpdp-shown');
    }

    var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-kpdp-tab]'));
    var pairs = tabs
      .map(function (tab) {
        var id = (tab.getAttribute('href') || '').slice(1);
        return { tab: tab, target: id ? document.getElementById(id) : null };
      })
      .filter(function (pair) {
        return pair.target;
      });
    if (!pairs.length) return;

    function mark() {
      sync();
      var line = nav.getBoundingClientRect().bottom + 24;
      var current = pairs[0];
      pairs.forEach(function (pair) {
        if (pair.target.getBoundingClientRect().top <= line) current = pair;
      });
      pairs.forEach(function (pair) {
        if (pair === current) pair.tab.setAttribute('aria-current', 'true');
        else pair.tab.removeAttribute('aria-current');
      });
    }

    var queued = false;
    window.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          mark();
        });
      },
      { passive: true }
    );
    mark();
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  function init() {
    updateShippingBar();
    initUpgrade();
    initSubnav();

    document.addEventListener('cart:updated', updateShippingBar);
    document.addEventListener('on:cart:change', updateShippingBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
